/** @format */

import {Modal, ModalHeader, ModalFooter} from '@sttark/design-system';
import {InputWithErrorHandler, handleChange} from 'frontier-form';
import {useSave} from 'frontier/components/form/use_save';
import {IfElse} from 'frontier-utilities';
import update from 'immutability-helper';
import {useForm} from 'frontier-form';
import React, {useState} from 'react';

export const RequestAdd = props => {
    const {companyId, children, onSuccessfulSend} = props;

    const {formData, setFormData, updateFormData} = useForm({email: ''});
    const [isModalOpen, setIsModalOpen] = useState(false);

    const {isSaving: isPending, save, error} = useSave('/account/user-merge-requests/add');

    const handleAddRequest = async () => {
        const {body} = await save({
            company_id: companyId,
            email: formData.email
        });

        setFormData({email: ''});
        onSuccessfulSend(body.requests);
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setEmail('');
    };

    const handleChange = target => {
        updateFormData(target);
    };

    // add click handler to the child component
    const enhancedTriggerChild = React.cloneElement(children, {
        onClick: () => setIsModalOpen(true)
    });

    return (
        <>
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(!isModalOpen)} bodyHeightAuto>
                <ModalHeader>Invite User</ModalHeader>
                <div>
                    <p className="m-0 p-0">
                        Enter the email address of the user you wish to invite.
                    </p>
                    <Form onChange={handleChange} email={formData.email} error={error} />
                </div>
                <ModalFooter>
                    <IfElse condition={isPending}>
                        <div className="d-flex align-items-center justify-content-end">
                            <button className="btn btn-disabled bg-structure-dark color-structure-darkest">
                                <b>Sending...</b>
                            </button>
                        </div>

                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <button onClick={handleClose} className="btn btn--secondary">
                                <b>Cancel</b>
                            </button>
                            <button onClick={handleAddRequest} className="btn btn--primary">
                                <b>Send Invite</b>
                            </button>
                        </div>
                    </IfElse>
                </ModalFooter>
            </Modal>
            {enhancedTriggerChild}
        </>
    );
};

const Form = handleChange(props => {
    return (
        <InputWithErrorHandler
            onChange={props.onInputChange.bind(this, 'email')}
            placeholder="*Enter email address to invite"
            value={props.email}
            error={props.error}
            className="w-100"
            label="Email"
            name="email"
            type="text"
            newestds
            required
        />
    );
});
